import { ComponentProps, useMemo } from "react"

import { twMerge } from "tailwind-merge"

import { useFieldContext } from "./FieldProvider"
import { dataFlag } from "~/src/lib/jsx"

export type FieldLabel = { optional?: boolean } & ComponentProps<"label">

/**
 * A Beekit skin of the native label element that forwards its ref, and populates `for` from the field context.
 */
export function FieldLabel(props: FieldLabel) {
  const { id, className, optional: optional_, children: children_, ...restProps } = props

  const fieldContext = useFieldContext()
  const htmlFor = useMemo(() => id ?? fieldContext?.inputId, [id, fieldContext?.inputId])
  const children = useMemo(() => children_ ?? fieldContext?.label, [children_, fieldContext?.label])

  const optional = useMemo(() => optional_ ?? fieldContext?.optional, [optional_, fieldContext?.optional])

  return children != null ? (
    <label
      htmlFor={htmlFor}
      className={twMerge("font-medium text-gray-700", className)}
      {...dataFlag(fieldContext?.hasErrors, "errored")}
      {...restProps}
    >
      {children}
      {optional && <span className="text-xs font-normal text-gray-500"> - Optional</span>}
    </label>
  ) : (
    <></>
  )
}
